module.exports = {
  metadata: {
    title: "turingsecure",
    description: "Website created with create-tpws-website",
    author: "https://turingpages.de",
    generator: "turingpages",
  },

  tpws: {
    defaultLocale: "en",
    dynamicTemplate: "./src/templates/dynamic-template.js",
    subfont: false,
    allowHtml: true,
  },

  strapi: {
    collectionTypes: [
      "security-page",
      "certificate",
      "certificate-template",
      "issue-template",
      "issue-tag",
      "issue-category",
      "issue-text",
      "pricing-attribute",
      "pricing-section",
      "pricing-template",
      "pricing-tier",
    ],
    singleTypes: [],
  },
};
